module.exports = __webpack_public_path__ + "static/assets/bc6bc02e0931cc10c6507a78b12ae02e.png";